var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { diff } from '@egjs/list-differ';
import Element, { defaultSetting } from './Element';
import { shapeKeys } from './Text';
import { unionBBox, ceilBBox } from '../utils/bbox';
import * as lodash from '../utils/lodash';
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'group';
        _this.svgTagName = 'g';
        _this.fillAble = false;
        _this.strokeAble = false;
        _this.shapeKeys = shapeKeys;
        _this._length = 0;
        _this._chunks = [];
        return _this;
    }
    Object.defineProperty(Group.prototype, "size", {
        get: function () {
            return this._length;
        },
        enumerable: true,
        configurable: true
    });
    Group.prototype.getDefaultAttr = function () {
        return __assign({}, _super.prototype.getDefaultAttr.call(this));
    };
    Object.defineProperty(Group.prototype, "isGroup", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Group.prototype.onAttrChange = function (key, value, oldValue) {
        _super.prototype.onAttrChange.call(this, key, value, oldValue);
        if (shapeKeys.indexOf(key) !== -1) {
            this.dirtyTextChildBBox();
        }
    };
    Group.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['fontSize']);
    };
    Group.prototype.computeBoundingClientRect = function () {
        return this.getBBox();
    };
    Group.prototype.getCurrentDirtyRect = function () {
        var bboxList = lodash.flatten(this.children()
            .filter(function (item) { return item.attr.display; })
            .map(function (child) { return child.getDirtyRects(); }));
        return ceilBBox(unionBBox(bboxList));
    };
    Group.prototype.computeBBox = function () {
        var bboxList = this.children()
            .filter(function (item) { return item.attr.display; })
            .map(function (child) { return child.getBoundingClientRect(); });
        return unionBBox(bboxList);
    };
    Group.prototype.mounted = function () {
        _super.prototype.mounted.call(this);
        if (this._chunks.length) {
            this.onChunkChange();
        }
        this.eachChild(function (child) { return child.mounted(); });
    };
    Group.prototype.dirtyTransform = function () {
        _super.prototype.dirtyTransform.call(this);
        this.eachChild(function (child) { return child.dirtyGlobalTransform(); });
    };
    Group.prototype.dirtyGlobalTransform = function () {
        _super.prototype.dirtyGlobalTransform.call(this);
        this.eachChild(function (child) { return child.dirtyGlobalTransform(); });
    };
    Group.prototype.add = function (item, dirty) {
        if (dirty === void 0) { dirty = true; }
        if (!item) {
            return;
        }
        if (item.parentNode === this) {
            this._moveToTail(item);
            dirty && item.dirty();
            return this;
        }
        if (!this.firstChild) {
            this.firstChild = this.lastChild = item;
        }
        else {
            item.prevSibling = this.lastChild;
            this.lastChild.nextSibling = item;
            this.lastChild = item;
        }
        item.nextSibling = null;
        this._length += 1;
        this._mountNode(item, dirty);
        return this;
    };
    Group.prototype.prepend = function (item) {
        if (!this.firstChild) {
            return this.add(item);
        }
        item.nextSibling = this.firstChild;
        this.firstChild.prevSibling = item;
        this.firstChild = item;
        this._length += 1;
        this._mountNode(item);
    };
    // https://developer.mozilla.org/zh-CN/docs/Web/API/Node/insertBefore
    // public insertBefore(newNode: T, refNode: T | null) {
    //   if (!refNode) {
    //     return this.add(newNode);
    //   }
    //   if (refNode.prevSibling === newNode || refNode.parentNode !== this || newNode === refNode) {
    //     return;
    //   }
    //   if (newNode.parentNode) {
    //     newNode.parentNode.remove(newNode);
    //     if (this.ownerRender?.renderer === 'svg') {
    //       const newDom = this._findSVGDomNode(newNode);
    //       const prevDom = this._findSVGDomNode(refNode);
    //       if (newDom && prevDom && prevDom.parentNode) {
    //         prevDom.parentNode.insertBefore(newDom, prevDom);
    //       }
    //     }
    //   }
    //   newNode.nextSibling = refNode;
    //   if (refNode.prevSibling) {
    //     refNode.prevSibling.nextSibling = newNode;
    //     newNode.prevSibling = refNode.prevSibling;
    //   } else {
    //     this.firstChild = newNode;
    //   }
    //   refNode.prevSibling = newNode;
    //   this._length += 1;
    //   this._mountNode(newNode);
    // }
    Group.prototype.addAll = function (items) {
        var _this = this;
        items.forEach(function (item) { return _this.add(item); });
        return this;
    };
    Group.prototype.addChunk = function (items) {
        if (items === void 0) { items = []; }
        if (items.length === 0) {
            return this;
        }
        this._chunks.push(items);
        this.onChunkChange();
        return this;
    };
    Group.prototype.replaceChunks = function (chunks) {
        this._chunks = chunks;
        this.onChunkChange();
    };
    Group.prototype.clearChunks = function () {
        this._chunks = [];
        this.onChunkChange();
    };
    Group.prototype.getChunks = function () {
        return this._chunks;
    };
    Group.prototype.onChunkChange = function () {
        if (this.ownerRender) {
            if (this._chunks.length) {
                this.ownerRender.chunksElement.add(this);
                this.ownerRender.nextTick();
            }
            else {
                this.ownerRender.chunksElement.delete(this);
            }
        }
    };
    Group.prototype.mountChunk = function (chunkItems) {
        var _this = this;
        this._chunks = this._chunks.filter(function (chunk) { return chunk !== chunkItems; });
        chunkItems.forEach(function (item) { return _this.add(item, false); });
        if (this._chunks.length === 0) {
            this.ownerRender.chunksElement.delete(this);
        }
    };
    Group.prototype.remove = function (element) {
        if (element.parentNode !== this) {
            console.warn('remove component not child of this group');
            return;
        }
        if (element === this.firstChild) {
            this.firstChild = element.nextSibling;
        }
        if (element === this.lastChild) {
            this.lastChild = element.prevSibling;
        }
        if (element.nextSibling) {
            element.nextSibling.prevSibling = element.prevSibling;
        }
        if (element.prevSibling) {
            element.prevSibling.nextSibling = element.nextSibling;
        }
        element.prevSibling = null;
        element.nextSibling = null;
        this._length--;
        element.dirty();
        element.destroy();
        this.dirtyBBox();
    };
    Group.prototype.clear = function () {
        var _this = this;
        this.children().forEach(function (item) { return _this.remove(item); });
        this._length = 0;
        this._chunks = [];
        this.dirty();
        this.dirtyBBox();
    };
    Group.prototype.childAt = function (position) {
        if (position < 0 || position >= this._length) {
            return null;
        }
        var current = null;
        var index = 0;
        if (this._length / 2 > position) {
            current = this.firstChild;
            while (index++ < position) {
                current = current.nextSibling;
            }
        }
        else {
            current = this.lastChild;
            index = this._length - 1;
            while (index-- > position) {
                current = current.prevSibling;
            }
        }
        return current;
    };
    Group.prototype.destroy = function () {
        if (this._chunks.length) {
            this.clearChunks();
        }
        this.clear();
        _super.prototype.destroy.call(this);
        this._chunks = [];
    };
    Group.prototype.getLeafNodesSize = function (max) {
        if (max === void 0) { max = Number.MAX_SAFE_INTEGER; }
        if (this.size >= max) {
            return max;
        }
        var nodes = this.childNodes;
        var count = 0;
        while (nodes.length) {
            var node = nodes.pop();
            count++;
            if (count >= max) {
                break;
            }
            if (node.isGroup) {
                if (node.size > max) {
                    return max;
                }
                node.eachChild(function (child) {
                    if (nodes.length < max) {
                        nodes.push(child);
                    }
                });
            }
        }
        return count;
    };
    Group.prototype.updateAll = function (list, transition) {
        var _this = this;
        if (transition === void 0) { transition = true; }
        if (this._chunks.length) {
            this.replaceChunks([]);
        }
        var prevList = this.children();
        if (prevList.length === 0) {
            this.addAll(list);
            return;
        }
        var nextList = prevList.slice();
        var result = diff(prevList, list, function (item, index) {
            var attr = item.attr;
            var key = attr.key !== undefined ? item.type + attr.key : "auto-key-" + item.type + "-" + index;
            return key;
        });
        result.removed.forEach(function (index) {
            nextList.splice(index, 1);
            var node = prevList[index];
            var parentNode = node.parentNode;
            node.parentNode = _this;
            _this.remove(node);
            if (parentNode !== _this) {
                node.parentNode = parentNode;
            }
        });
        result.ordered.forEach(function (_a, i) {
            var from = _a[0], to = _a[1];
            nextList.splice(from, 1);
            nextList.splice(to, 0, prevList[result.pureChanged[i][0]]);
        });
        result.maintained.forEach(function (_a) {
            var from = _a[0], to = _a[1];
            var prevElement = prevList[from];
            var nextElement = list[to];
            if (prevElement === nextElement) {
                prevElement.ownerRender = nextElement.ownerRender = _this.ownerRender;
                return;
            }
            if (nextElement.attr.ref) {
                nextElement.attr.ref.current = prevElement;
            }
            if (prevElement.isGroup) {
                prevElement.updateAll(nextElement.children(), transition);
                var chunks = nextElement.getChunks();
                prevElement.replaceChunks(chunks);
            }
            // todo clone matrix
            var dragOffset = nextElement.getDragOffset();
            prevElement.setDragOffset(dragOffset[0], dragOffset[1]);
            _this._diffUpdateElement(prevElement, nextElement, transition);
        });
        result.added.forEach(function (index) {
            _this.add(list[index]);
            nextList.splice(index, 0, list[index]);
        });
        this.firstChild = nextList[0];
        this.lastChild = nextList[nextList.length - 1];
        for (var i = 0; i < nextList.length; i++) {
            nextList[i].prevSibling = nextList[i - 1];
            nextList[i].nextSibling = nextList[i + 1];
        }
        this.afterUpdateAll();
    };
    Group.prototype.eachChild = function (callback) {
        var node = this.firstChild;
        while (node) {
            callback(node);
            node = node.nextSibling;
        }
        node = null;
    };
    Group.prototype.children = function () {
        var ret = [];
        var node = this.firstChild;
        while (node) {
            ret.push(node);
            node = node.nextSibling;
        }
        node = null;
        return ret;
    };
    Group.prototype.getAllLeafNodes = function (ret, filter) {
        this.eachChild(function (item) {
            if (item.attr.display === false) {
                return;
            }
            if (!item.isGroup) {
                if (filter(item)) {
                    ret.push(item);
                }
            }
            else {
                item.getAllLeafNodes(ret, filter);
            }
        });
        return ret;
    };
    Group.prototype.resetPickRGB = function () {
        _super.prototype.resetPickRGB.call(this);
        this.eachChild(function (child) { return child.resetPickRGB(); });
    };
    Group.prototype.dirtyClipTarget = function (clip) {
        _super.prototype.dirtyClipTarget.call(this, clip);
        this.eachChild(function (child) { return child.dirtyClipTarget(clip); });
    };
    Group.prototype.dirtyTextChildBBox = function () {
        this.eachChild(function (child) {
            if (child.type === 'text') {
                child.dirtyBBox();
            }
            if (child.isGroup) {
                child.dirtyTextChildBBox();
            }
        });
    };
    Group.prototype.onChildDirty = function () {
        var _a;
        (_a = this._refElements) === null || _a === void 0 ? void 0 : _a.forEach(function (ref) {
            ref.dirty();
            ref.dirtyTransform();
            ref.dirtyBBox();
        });
    };
    Group.prototype.afterUpdateAll = function () {
        // nothing
    };
    Group.prototype._mountNode = function (item, dirty) {
        if (dirty === void 0) { dirty = true; }
        item.parentNode = this;
        item.mounted();
        if (dirty) {
            item.dirty();
        }
        this.dirtyBBox();
    };
    Group.prototype._moveToTail = function (item) {
        var _a;
        if (this.lastChild === item) {
            return;
        }
        if (this.firstChild === item) {
            this.firstChild = item.nextSibling;
            this.firstChild.prevSibling = null;
            var last = this.lastChild;
            item.prevSibling = this.lastChild;
            this.lastChild = last.nextSibling = item;
            item.nextSibling = null;
        }
        else {
            item.prevSibling.nextSibling = item.nextSibling;
            if (item.nextSibling) {
                item.nextSibling.prevSibling = item.prevSibling;
            }
            item.prevSibling = this.lastChild;
            this.lastChild.nextSibling = item;
            item.nextSibling = null;
            this.lastChild = item;
        }
        if (((_a = this.ownerRender) === null || _a === void 0 ? void 0 : _a.renderer) === 'svg') {
            var dom = this._findSVGDomNode(item);
            if (dom && dom.parentNode) {
                dom.parentNode.appendChild(dom);
            }
            else {
                console.warn('dom not exist', item);
            }
        }
    };
    Group.prototype._diffUpdateElement = function (prevElement, nextElement, transition) {
        var prevAttr = prevElement.attr;
        var nextAttr = nextElement.attr;
        var _a = nextElement.attr, _b = _a.transitionDuration, transitionDuration = _b === void 0 ? defaultSetting.during : _b, _c = _a.transitionEase, transitionEase = _c === void 0 ? defaultSetting.ease : _c, _d = _a.transitionProperty, transitionProperty = _d === void 0 ? 'all' : _d, _e = _a.transitionDelay, transitionDelay = _e === void 0 ? 0 : _e;
        prevElement.startAttrTransaction();
        for (var key in prevAttr) {
            if (!(key in nextAttr)) {
                prevElement.removeAttr(key);
            }
        }
        if (!transition || transitionProperty === 'none' || transitionProperty.length === 0) {
            prevElement.setAttr(nextAttr);
        }
        else {
            // todo transition property array support
            var transitionAttr = transitionProperty === 'all' ? nextAttr : lodash.pick(nextAttr, transitionProperty);
            prevElement
                .stopAllAnimation()
                .animateTo(transitionAttr, transitionDuration, transitionEase, null, transitionDelay);
        }
        if (prevElement.$$CustomType) {
            prevElement.skipUpdate();
        }
        prevElement.endAttrTransaction();
    };
    Group.prototype._findSVGDomNode = function (item) {
        return this.ownerRender.getPainter().findDOMNode(item);
    };
    return Group;
}(Element));
export default Group;
